import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GridType } from '../app.const';
import { MetadataService } from '../metadata/metadata.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPageComponent implements OnInit {
  public gridTypes: typeof GridType = GridType;

  private readonly metadataService = inject(MetadataService);
  private readonly router = inject(Router);

  public ngOnInit() {
    this.metadataService.setLandingPage();
  }

  public navigateToGrid(gridType: GridType) {
    this.router.navigate([gridType]);
  }
}
